var $371a732b2494f452$exports = {};
$371a732b2494f452$exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5`,
    "brightness": `Lysstyrke`,
    "green": `Gr\xf8nn`,
    "hue": `Fargetone`,
    "lightness": `Lyshet`,
    "red": `R\xf8d`,
    "saturation": `Metning`
};


export {$371a732b2494f452$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
